<template>
  <div>
    <Table
      :data="resources"
      :columns="columns"
      size="small"
      highlight-row
      stripe
      max-height="700"
    >
      <template slot-scope="{ row }" slot="bank_name">
        {{ row.bank_account ? row.bank_account.bank_name : '' }}
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  props: {
    row: Object
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    resources () {
      return this.row.supplier_bank_accounts
    },
    columns () {
      return [
        {
          title: this.$t('supplier.bank'),
          slot: 'bank_name',
          width: 628
        },
        {
          title: this.$t('supplier.accountName'),
          key: 'account_name',
          width: 628
        },
        {
          title: this.$t('supplier.accountNumber'),
          key: 'account_number',
          width: 628
        }
      ]
    }
  }
}
</script>
